import { render, staticRenderFns } from "./VerifyEmployeeRegistrationDialog.vue?vue&type=template&id=dc32022a&scoped=true&"
import script from "./VerifyEmployeeRegistrationDialog.vue?vue&type=script&lang=js&"
export * from "./VerifyEmployeeRegistrationDialog.vue?vue&type=script&lang=js&"
import style0 from "./VerifyEmployeeRegistrationDialog.vue?vue&type=style&index=0&id=dc32022a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc32022a",
  null
  
)

export default component.exports